<template>
  <div class="authentications-page">
    <vs-popup title="" :active.sync="displayForgotPasswordPopup" class="forgot-password-popup" :style="insetStyle">
      <forgot-password :fromPopup="true" v-if="displayForgotPasswordPopup" @close="displayForgotPasswordPopup = false"
        @back="openLogin" @open-login="openLogin" @open-lost-access="openLostAccess"
        @open-forgot-password="openForgotPassword" @open-register="openRegister"></forgot-password>
    </vs-popup>
    <vs-popup title="" :active.sync="displayLoginPopup" class="login-popup" :style="insetStyle">
      <login :fromPopup="true" v-if="displayLoginPopup" @close="displayLoginPopup = false" @open-register="openRegister"
        @open-forgot-password="openForgotPassword" @open-lost-access="openLostAccess"
        @open-privacy-policy="openPrivacyPolicy" @closelogin="displayLoginPopup = !displayLoginPopup"></login>
    </vs-popup>
    <vs-popup title="" :active.sync="displayRegisterPopup" id="register-popup" class="register-popup" :style="insetStyle">
      <register :fromPopup="true" v-if="displayRegisterPopup" @close="displayRegisterPopup = false"
        @open-login="openLogin" @open-lost-access="openLostAccess" @open-forgot-password="openForgotPassword"
        @open-register="openRegister" @closeRegister="displayRegisterPopup = !displayRegisterPopup"></register>
    </vs-popup>
    <vs-popup title="" :active.sync="displayLostAccessPopup" id="lost-access-popup" class="lost-access-popup" :style="insetStyle">
      <lost-access :fromPopup="true" v-if="displayLostAccessPopup" @close="displayLostAccessPopup = false"
        @back="openLogin" @open-login="openLogin" @open-lost-access="openLostAccess"
        @open-forgot-password="openForgotPassword" @open-register="openRegister"></lost-access>
    </vs-popup>
    <vs-popup :title="$t('HELP_PRIVACY_POLICY').Title" :active.sync="displayPopupPrivacyPolicy"
      class="privacy-policy-modal" :style="insetStyle">
      <privacy-policy></privacy-policy>
    </vs-popup>
  </div>
</template>

<script>
import Login from '../../views/pages/Login.vue';
import Register from '../../views/pages/Register.vue';
import LostAccess from '../../views/pages/LostAccess.vue';
import ForgotPassword from '../../views/pages/ForgotPassword.vue';
import PrivacyPolicy from '../../views/pages/help/PrivacyPolicy.vue';
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
import biometryHelper from "@/helpers/biometry-helper";
import localStorageHelper from "@/helpers/local-storage-helper";
import authService from "@/providers/authService";
import AppConstants from "@/appConstants";
import store from "@/store/store";
import { getInsetStyle } from '../../helpers/inset-style-helper';

export default {
  props: {
    isDesktop: {
      type: Boolean,
      default: true,
      require: true
    }
  },
  components: {
    Login,
    Register,
    LostAccess,
    ForgotPassword,
    PrivacyPolicy,
  },
  data() {
    return {
      displayLoginPopup: false,
      displayRegisterPopup: false,
      displayForgotPasswordPopup: false,
      displayLostAccessPopup: false,
      displayPopupPrivacyPolicy: false,
      displayPopupContentExclusive: false
    }
  },
  computed: {
    insetStyle() {
      return getInsetStyle();
    },
    isNativeApp() {
      return checkDeviceTypeHelper.isNativeApp();
    },
    isReactApp() {
      return checkDeviceTypeHelper.isReactApp();
    },
  },
  methods: {
    openPrivacyPolicy() {
      this.displayPopupPrivacyPolicy = true;
    },
    openLogin() {
      if (this.isNativeApp
        && localStorageHelper.getBiometry() === "1"
      ) {
        if (this.isReactApp) {
          this.newTryLoginWithBiometry();
        } else {
          this.tryLoginWithBiometry();
        }
      } else {
        this.openLoginPopup();
      }
    },
    tryLoginWithBiometry() {
      biometryHelper.hasBiometry(
        () => {
          this.loadSecretFromBiometry();
        },
        (error) => {
          console.warn('Biometrics unavailable:', error);
          this.openLoginPopup();
        }
      );
    },
    async newTryLoginWithBiometry() {
      if (this.isNativeApp) {
        try {
          const biometryType = await biometryHelper.waitCheckHasBiometry();
          console.log('[biometryType]', biometryType);
          if (biometryType) {
            this.newLoadSecretFromBiometry();
          } else {
            console.warn('biometryType unavailable');
            this.openLoginPopup();
          }
        } catch (error) {
          console.warn('biometryType unavailable');
          this.openLoginPopup();
        }
      } else {
        console.warn('is not native app');
        this.openLoginPopup();
      }
    },
    loadSecretFromBiometry() {
      biometryHelper.loadSecret((secret) => {
        console.log('[loadSecretFromBiometry]', secret)
        // localStorageHelper.updateBiometry("1");
        // this.$store.dispatch('updateBiometrySecrets', refreshToken);
        const form = {
          refreshToken: secret
        };
        authService.getAccessTokenFromRefreshToken(form, new URLSearchParams())
          .then(response => {
            localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN, true);
            localStorageHelper.setCurrentUser(response);
            store.dispatch('updateUserAuthenticated', true);
            // this.emit(AppConstants.EVENT_LOGIN, {
            //   loggedIn: true,
            //   loginData: response
            // });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          });
      }, (error) => {
        // messagesNotifyHelper.errorNotify((this.$t('LOGIN').Notify_Error_Title), 'Erro ao carregar biometria');
        this.openLoginPopup();
        // biometryHelper.registerSecret('', null, null);
        // localStorageHelper.updateBiometry("0");
      });
    },
    async newLoadSecretFromBiometry() {
      try {
        const secret = await biometryHelper.waitGetBiometrySecret();
        if (secret) {
          const form = {
            refreshToken: secret
          };
          authService.getAccessTokenFromRefreshToken(form, new URLSearchParams())
            .then(response => {
              localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN, true);
              localStorageHelper.setCurrentUser(response);
              store.dispatch('updateUserAuthenticated', true);
              // this.emit(AppConstants.EVENT_LOGIN, {
              //   loggedIn: true,
              //   loginData: response
              // });
              setTimeout(() => {
                window.location.reload();
              }, 100);
            });
        } else {
          console.log('[Login][Fingerprint/FaceID] cannot load secrets, opening login popup');
          this.openLoginPopup();
        }
      } catch (error) {
        this.openLoginPopup();
      }
    },
    openLoginPopup() {
      this.displayLoginPopup = true;
      this.displayRegisterPopup = false;
      this.displayForgotPasswordPopup = false;
      this.displayLostAccessPopup = false;
      this.displayPopupPrivacyPolicy = false;
    },
    openRegister() {
      this.displayRegisterPopup = true;
      this.displayLoginPopup = false;
      this.displayForgotPasswordPopup = false;
      this.displayLostAccessPopup = false;
      this.displayPopupPrivacyPolicy = false;
    },
    openForgotPassword() {
      this.displayForgotPasswordPopup = true;
      this.displayRegisterPopup = false;
      this.displayLoginPopup = false;
      this.displayLostAccessPopup = false;
      this.displayPopupPrivacyPolicy = false;
    },
    openLostAccess() {
      this.displayRegisterPopup = false;
      this.displayLoginPopup = false;
      this.displayForgotPasswordPopup = false;
      this.displayLostAccessPopup = true;
      this.displayPopupPrivacyPolicy = false;
    },
  },
}
</script>

<style></style>
